import { Component } from '@angular/core';

import {
  SkyModalService,
  SkyModalCloseArgs
} from '../../core';

import { SkyModalDemoContext } from './modal-demo-context';
import { SkyModalDemoFormComponent } from './modal-demo-form.component';
import { SkyModalDemoTiledFormComponent } from './modal-demo-tiled-form.component';


export class SkyModalDemoComponent {
  constructor(private modal: SkyModalService) { }

  public openModal(type: string) {
    const context = new SkyModalDemoContext();
    context.valueA = 'Hello';

    const options: any = {
      providers: [{ provide: SkyModalDemoContext, useValue: context }],
      ariaDescribedBy: 'docs-modal-content'
    };

    let modalInstanceType = SkyModalDemoFormComponent;

    switch (type) {
      case 'fullScreenModal':
      options.fullPage = true;
      break;
      case 'smallModal':
      options.size = 'small';
      break;
      case 'largeModal':
      options.size = 'large';
      break;
      case 'tiledModal':
      modalInstanceType = SkyModalDemoTiledFormComponent;
      break;
      case 'withHelpHeader':
      options.helpKey = 'demo-key.html';
      break;
      default:
      break;
    }

    const modalInstance = this.modal.open(modalInstanceType, options);

    modalInstance.closed.subscribe((result: SkyModalCloseArgs) => {
      console.log(`Modal closed with reason: ${result.reason} and data: ${result.data}`);
    });

    modalInstance.helpOpened.subscribe((helpKey: string) => {
      context.eventMessage =  `
        Modal header help was invoked with the following help key: ${helpKey}
      `;
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-modal-demo',
  template: `<button type="button" class="sky-btn sky-btn-default" (click)="openModal('defaultModal')">
  Open modal
</button>

<button type="button" class="sky-btn sky-btn-default" (click)="openModal('smallModal')">
  Open small modal
</button>

<button type="button" class="sky-btn sky-btn-default" (click)="openModal('largeModal')">
  Open large modal
</button>

<button type="button" class="sky-btn sky-btn-default" (click)="openModal('fullScreenModal')">
 Open full-screen modal
</button>

<button type="button" class="sky-btn sky-btn-default" (click)="openModal('tiledModal')">
  Open tiled modal
</button>

<button type="button" class="sky-btn sky-btn-default" (click)="openModal('withHelpHeader')">
  Open modal with help header
</button>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyModalService, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
